import { Card, Collapse, Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconHeading } from '@tabler/icons-react';
import { useState } from 'react';
import templateWizardFormFields from '../../../constants/templateWizardFormFields';
import TemplateFields from './templateFields';

const TitleForm = ({ disabled, handleChangeStyles, productBlockStyles, handleChangeColors }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <UnstyledButton onClick={() => setOpen(!open)} w="100%">
          <Group justify="space-between">
            <Group gap="xs">
              <IconHeading size={18} color="var(--mantine-color-dimmed)" />
              <Text fw={500}>Block Title</Text>
            </Group>
            {open ? <IconChevronUp size={18} /> : <IconChevronDown size={18} />}
          </Group>
        </UnstyledButton>
      </Card.Section>
      <Collapse expanded={open}>
        <Card.Section inheritPadding py="sm">
          <TemplateFields
            disabled={disabled}
            handleChangeStyles={handleChangeStyles}
            productBlockStyles={productBlockStyles}
            handleChangeColors={handleChangeColors}
            fieldConfigs={templateWizardFormFields.titleFields}
          />
        </Card.Section>
      </Collapse>
    </Card>
  );
};

export default TitleForm;
